jQuery(document).ready(function($){ //eslint-disable-line no-unused-vars
	
	//********************************
	//AJAX PRODUCTS
	//********************************

	
	//AJAX PRODUCTS FUNCTION
	//********************************
	function wpkFilterAjaxProducts(tagsArray, termsArray, paged, post_per_page, total_pages) {

		//For pagination
		paged++; //We already have one by default

		//Vars
		var data = {
			'action': 'wpk_products_ajax', //function name in function.php
			'post_per_page': post_per_page,
			'total_pages': total_pages,
			'paged': paged, //Pagination (add 1 for next page)
			'tags': tagsArray, //City terms
			'terms': termsArray //Type terms
		};

		//Query
		$.ajax({
			url : wpk_script_object.ajaxurl, // AJAX handler
			data : data, //Vars
			type : 'POST',
			beforeSend : function () {
				//Fade out objects
				$('#products-filter-list').addClass('loading');
				//Stop ajax from repeating it self while loading
				$(window).data('ajaxready', false);
			},
			success : function(result){
				//If loop returns posts
				if(result) {
					//Replace result
					$('#products-filter-list-ajax').html(result);
					//Continue ajax
					$('.wpk-animate').addClass('in-view');
					$(window).data('ajaxready', true);
				} else {
					//Last post. Stop ajax
					$(window).data('ajaxready', false);
					//Message
					$('#products-filter-list-ajax').html('<p class="text-center my-4">Vi hittade inte fler inlägg.</p>');
				}
			},
			complete: function() {
				//Remove fade
				$('#products-filter-list').removeClass('loading');
			}
		});
	}


	//TERM VALUES
	//********************************
	function wpkGetTerms() {

		var tagsArray = [];
		$('#tags-list input:checkbox:checked').each(function () {
			tagsArray.push($(this).val());
		});
		
		var termsArray = [];
		$('#terms-list input:checkbox:checked').each(function () {
			termsArray.push($(this).val());
		});

		return[tagsArray, termsArray];
	}

	//PRODUCTS FILTER
	//********************************
	$('#products-filter input:checkbox').on('click', function(){
		
		//Get checked terms 
		var filterValues = wpkGetTerms();

		var paged = $('#products-filter-load-more').data('paged');

		var post_per_page = $('#products-filter-load-more').data('post_per_page');

		var total_pages = $('#products-filter-load-more').data('total_pages');

		//Run function on all clicks, even on empty checkboxes
		//wpkLoadAjaxProducts(tagsArray, termsArray);
		wpkFilterAjaxProducts(filterValues[0], filterValues[1], paged, post_per_page, total_pages);
	});
	

	//PRODUCTS LOAD MORE BUTTON
	//********************************
	//catch a live object (loaded by ajax)
	$(document).on('click', '#products-filter-load-more', function () {

		var paged = $(this).data('paged');

		var post_per_page = $(this).data('post_per_page');

		var total_pages = $(this).data('total_pages');

		wpkFilterAjaxProducts('', '', paged, post_per_page, total_pages);
	});
	
	




	//********************************
	//AJAX LOAD POST FUNCTION
	//********************************
	function wpkLoadPostbyYear(year, cat) {
		
		//Use a global data var to avoid multiple loading animations when scrolling to fast
		if ($(window).data('ajaxready') === false) {
			return;
		}
		
		//Vars
		var data = {
			'action': 'wpk_post_years', //function name in function.php
			'year': year, //Type terms
			'cat': cat
		};

		//Query
		$.ajax({
			url : wpk_script_object.ajaxurl, // AJAX handler
			data : data, //Vars
			type : 'POST',
			beforeSend : function () {
				//Remove all projects
				$('#post-list').html('');
				//Add a loader
				$('#post-list').append('<div id="wpk-loader-container" class="d-block text-center my-4"><div class="wpk-loader" role="status"><span></span></div></div>');
				//Stop ajax from repeating it self while loading
				$(window).data('ajaxready', false);
			},
			success : function(result){
				//Remove loader
				$('#wpk-loader-container').remove();
				//If loop returns posts
				if(result) {
					$('#post-list').html(result);	
					//Continue ajax
					$(window).data('ajaxready', true);
				} else {
					//Last post. Stop ajax
					$(window).data('ajaxready', false);
					//Message
					$('#post-list').append('<p class="text-center my-4">Vi hittade inte fler inlägg.</p>');
				}
			},
			complete: function() {
				//Remove loader
				$('#wpk-loader-container').remove();
				//Rebind in-view. Create new targets from the new #post-list div
				var targetsAjax = document.querySelectorAll('#post-list .wpk-animate, #post-list .is-style-wpk-animate');
				//Run in-view function with new targets
				wpkImageLoader(targetsAjax);

			}
		});
	}
	
	
	//********************************
    //POST FILTER FUNCTION
	//********************************
	$('#post-filter .dropdown-item').on('click', function(){

		var year = $(this).attr('data-year');
		var cat = $(this).attr('data-cat');
		
		//Run function on all clicks, even on empty checkboxes
		wpkLoadPostbyYear(year, cat);
		
	});
	
	
}); //End jQuery